import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTableComponent } from './custom-table.component';
import { CustomTableHeaderComponent } from './custom-table-header/custom-table-header.component';
import { CustomTableRowComponent } from './custom-table-row/custom-table-row.component';
import { CustomTableCellComponent } from './custom-table-cell/custom-table-cell.component';
import { DynamicStylesheetModule } from '../dynamic-stylesheet/dynamic-stylesheet.module';
import { CustomTableColComponent } from './custom-table-col/custom-table-col.component';

@NgModule({
  declarations: [
    CustomTableComponent,
    CustomTableHeaderComponent,
    CustomTableRowComponent,
    CustomTableCellComponent,
    CustomTableColComponent,
  ],
  exports: [
    CustomTableComponent,
    CustomTableHeaderComponent,
    CustomTableCellComponent,
    CustomTableRowComponent,
    CustomTableColComponent,
  ],
  imports: [CommonModule, DynamicStylesheetModule],
})
export class CustomTableModule {}
